<template>
  <div class="wrap">
    <div class="nav">
      <slot />
      <div class="analytic__toggler">
        Analytics View
        <Toogle :value="toggleStatus" @toggle="value => handleToggle(value)" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Toogle from "../resuables/toggle.vue";
export default {
  components: { Toogle },
  computed: {
    ...mapState({
      toggleStatus: state => state.rnpl.showAnalytics
    })
  },

  methods: {
    handleToggle(value) {
      this.$store.commit("rnpl/toggleAnalytics", value);
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap {
  padding-top: 38px;
  padding-bottom: 28px;
  .nav {
    width: 100%;
    height: fit-content;
    display: flex;
    justify-content: space-between;
    align-content: center;

    &__left {
      .title {
        font-weight: 700;
        font-size: 24px;
        line-height: 30px;
        color: #000000;
      }
      .sub-title {
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        color: #242428;
      }
    }
    .analytic__toggler {
      // width: 212px;
      height: 60px;
      border-radius: 80px;
      display: flex;
      column-gap: 16px;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: space-between;
      padding: 0 24px;
      font-weight: 600;
      font-size: 14px;
      line-height: 18px;
      background: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/RNPLNavbar.vue